/**
 * IMPORTS
 */

import { myTasksRepository } from "@/repositories/my-tasks";

/**
 * Função que atualiza uma tarefas 🛠️.
 */
const handleAtualizarTarefa = async (accessToken: string, idRemessa: number, payload: any) => {
  try {
    const data = await myTasksRepository.handleAtualizarTarefa(accessToken, idRemessa, payload);

    return data;
  } catch (error: any) {
    console.log("ERROR ATULIZAR TAREFA: ", error);

    return error;
  }
};

/**
 * EXPORTS
 */
export { handleAtualizarTarefa };
